<h1 *ngIf="showVodafoneTitle">Vodafone <span>Analytics</span></h1>
<div class="container">
  <div>
    <img class="logo" [src]="logo" />
    <div class="title-wrapper" *ngIf="showTitle">
      <p>
        {{ title | translate
        }}<span *ngIf="subtitle"><br />{{ subtitle | translate }}</span>
      </p>
    </div>
    <button class="carto" type="button" (click)="signIn()">
      <span>{{ 'Sign In' | translate }}</span>
    </button>
    <div class="legal" [class.open]="legalOpen">
      <h3>{{ 'Legal Notice' | translate }}</h3>
      {{ 'Unauthorized access or use of this system owned by' | translate }}
      <strong>{{ 'Vodafone Greece' | translate }}</strong>
      {{
        'is prohibited and may be prosecuted under civil and criminal law in accordance with the regulations in force in the country of demonstration at any time. You are informed that all activity carried out in this environment is monitored, registered and subject to periodic audits.'
          | translate
      }}
      <span class="gradient"></span>
    </div>
    <button class="read-more" type="button" (click)="toggleLegal()">
      <p *ngIf="!legalOpen">{{ 'Read more' | translate }}</p>
      <p *ngIf="legalOpen">{{ 'Understood ' | translate }}</p>
    </button>
  </div>
  <div class="logo-footer">
    <p class="label">Powered by</p>
    <div class="logos">
      <img width="124" src="/assets/img/brands/politis/logo-politis-ooh.png" />
      <img src="/assets/img/logos/vf-with-text.svg" />
      <img src="/assets/img/logos/carto-logo-negative.svg" />
    </div>
    <p class="label">Serial No. CARTOPOOH2021</p>
  </div>
</div>
<app-footer [class.transparent]="true"></app-footer>
